import { type AdSet } from "~/ui-rtk/api/types/paid-media.types"
import { type AdForgeFilters } from "./validation-schema"
import AdSetItem from "./AdSetItem"

interface AdSetListProps {
  adSets: AdSet[]
  selectedAdSets: Record<string, boolean>
  onToggleAdSet: (adSetId: string) => void
  onShowCampaign: (campaignId: string) => void
  isLoadingAdSets: boolean
  isLoadingMore: boolean
  hasMore: boolean
  campaignSearchQuery: string
  filters: AdForgeFilters
}

export default function AdSetList({
  adSets,
  selectedAdSets,
  onToggleAdSet,
  onShowCampaign,
  isLoadingAdSets,
  isLoadingMore,
  hasMore,
  campaignSearchQuery,
  filters,
}: AdSetListProps) {
  return (
    <div className="space-y-3 relative">
      {/* Loading overlay for filter changes */}
      {isLoadingAdSets && adSets.length > 0 && (
        <div className="absolute inset-0 bg-system-blue-800/80 backdrop-blur-sm rounded-lg flex items-center justify-center z-10">
          <div className="flex flex-col items-center gap-3 text-white">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-brand"></div>
            <span className="text-sm">Applying filters...</span>
          </div>
        </div>
      )}

      {isLoadingAdSets && adSets.length === 0 && (
        <div className="text-gray-400 text-center py-8">
          <div className="flex flex-col items-center gap-3">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand"></div>
            <span>Loading ad sets...</span>
          </div>
        </div>
      )}
      {!(isLoadingAdSets && adSets.length === 0) && adSets.length ? (
        <>
          {adSets.map(adSet => (
            <AdSetItem
              key={adSet.id}
              adSet={adSet}
              isSelected={selectedAdSets[adSet.id] || false}
              onToggle={() => onToggleAdSet(adSet.id)}
              onShowCampaign={() => onShowCampaign(adSet.campaign_id)}
            />
          ))}
          {isLoadingMore && (
            <div className="text-gray-400 text-center py-4">
              <div className="flex flex-col items-center gap-2">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-brand"></div>
                <span className="text-sm">Loading more ad sets...</span>
              </div>
            </div>
          )}
          {!hasMore && adSets.length > 0 && (
            <div className="text-gray-400 text-center py-2 text-sm">
              All ad sets loaded
            </div>
          )}
        </>
      ) : (
        <div className="text-gray-400 text-center py-4">
          {(() => {
            const hasActiveFilters =
              campaignSearchQuery.trim() ||
              filters.campaignFilter ||
              filters.statusFilter !== "ACTIVE" ||
              filters.minSpend ||
              filters.maxSpend
            return hasActiveFilters
              ? "No ad sets match your filters"
              : "No ad sets found"
          })()}
        </div>
      )}
    </div>
  )
}
